var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1321314375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3541 6.53112H14.75V6.5H8V9.5H12.2386C11.6202 11.2464 9.95862 12.5 8 12.5C5.51487 12.5 3.5 10.4851 3.5 8C3.5 5.51487 5.51487 3.5 8 3.5C9.14712 3.5 10.1907 3.93275 10.9854 4.63962L13.1067 2.51825C11.7672 1.26987 9.9755 0.5 8 0.5C3.85812 0.5 0.5 3.85812 0.5 8C0.5 12.1419 3.85812 15.5 8 15.5C12.1419 15.5 15.5 12.1419 15.5 8C15.5 7.49712 15.4482 7.00625 15.3541 6.53112Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.36462 4.50912L3.82875 6.31625C4.4955 4.6655 6.11025 3.5 7.99987 3.5C9.147 3.5 10.1906 3.93275 10.9852 4.63962L13.1066 2.51825C11.7671 1.26987 9.97537 0.5 7.99987 0.5C5.11912 0.5 2.62087 2.12637 1.36462 4.50912Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00011 15.5C9.93736 15.5 11.6976 14.7586 13.0285 13.553L10.7072 11.5888C9.92894 12.1807 8.97791 12.5008 8.00011 12.5C6.04937 12.5 4.39299 11.2561 3.76899 9.52026L1.32324 11.4046C2.56449 13.8335 5.08524 15.5 8.00011 15.5Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.3541 6.53112H14.75V6.49999H8V9.49999H12.2386C11.9428 10.3311 11.41 11.0574 10.706 11.5891L10.7071 11.5884L13.0284 13.5526C12.8641 13.7019 15.5 11.75 15.5 7.99999C15.5 7.49712 15.4482 7.00624 15.3541 6.53112Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/ic_google.60ff89bb98f50d42ff9ec2efb743b461.svg";
export { ForwardRef as ReactComponent };